import { render, staticRenderFns } from "./DataRequestComponent.vue?vue&type=template&id=1171099c&scoped=true&"
import script from "./DataRequestComponent.vue?vue&type=script&lang=ts&"
export * from "./DataRequestComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DataRequestComponent.vue?vue&type=style&index=0&id=1171099c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171099c",
  null
  
)

export default component.exports